import { ExperienceSource } from 'model/IExperience';

const MIN_ORIGINALS_FOR_TOP5 = 5;
const MIN_RESULTS_FOR_TOP5 = 5;
const MIN_ORIGINALS_FOR_TOP3 = 3;
const MIN_RESULTS_FOR_TOP3 = 3;

export default function findTopResults(
  experiences: ExperienceSource[],
  totalResults: number,
  maxResults = 5,
): ExperienceSource[] {
  const offlineExperiences = experiences.filter(
    (experience) => experience.experienceType !== 'online',
  );
  const nrOfExperiences = offlineExperiences.length;

  if (
    nrOfExperiences >= MIN_ORIGINALS_FOR_TOP5 &&
    totalResults >= MIN_RESULTS_FOR_TOP5
  ) {
    return offlineExperiences.slice(
      0,
      Math.min(maxResults, offlineExperiences.length),
    );
  }
  if (
    nrOfExperiences >= MIN_ORIGINALS_FOR_TOP3 &&
    totalResults >= MIN_RESULTS_FOR_TOP3
  ) {
    return offlineExperiences.slice(0, Math.min(3, offlineExperiences.length));
  }
  return [];
}
